import { Box, Heading, NavList, Paragraph } from '@deckee/deck-hand';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { setSideBar } from '../../../../services/store/modules/app-controls';
import {
  resetTags,
  selectSelectedTypeKey,
  setType,
} from '../../../../services/store/modules/incident-report';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { AvailableTypesList } from '../../../../services/store/modules/incident-report/models';

const StyledPhone = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
`;

const MarinePollutionBlock: FC<{
  heading: string;
  children?: React.ReactNode;
}> = ({ heading, children }) => (
  <Box color="black" px={2} py={3}>
    <Box fontWeight="bold">{heading}</Box>
    {children && <Box mt={2}>{children}</Box>}
  </Box>
);

const MarinePollutionIncidentPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const selectedType = useSelector(selectSelectedTypeKey);

  const handleSelectType = async (type: AvailableTypesList) => {
    await captureEvent({
      type: 'incident: marine pollution - type selected',
      payload: {
        incidentType: type,
      },
      sendToAmplitude: true,
    });

    dispatch(setType(type));
    // Clear any previous tags when a new type is selected
    if (type !== selectedType) dispatch(resetTags());
    history.push(`location`);
  };

  useEffect(() => {
    dispatch(setSideBar());
  }, [dispatch]);
  return (
    <BasicDrawerLayout
      showMenuBar={false}
      heading="Reporting marine pollution"
      onBack={() => history.goBack()}
    >
      <Box p={3}>
        <Heading level={5}>You have identified marine pollution!</Heading>
        <Paragraph pb={3}>
          Use the instructions below that match the type of pollution you have
          found.{' '}
        </Paragraph>

        <NavList>
          <NavList.Item chevron onClick={() => handleSelectType('Oil spill')}>
            <MarinePollutionBlock heading="Oil spill" />
          </NavList.Item>

          <NavList.Item href="tel:131136">
            <MarinePollutionBlock heading="Algae bloom">
              Contact <StyledPhone>13 11 36</StyledPhone>
            </MarinePollutionBlock>
          </NavList.Item>
          <NavList.Item href="tel:0894229924">
            <MarinePollutionBlock heading="Sewage">
              Contact <StyledPhone>08 9422 9924</StyledPhone>
            </MarinePollutionBlock>
          </NavList.Item>
        </NavList>
      </Box>
    </BasicDrawerLayout>
  );
};

export default MarinePollutionIncidentPage;
